import React from 'react';
import styled from 'styled-components';
import { globalActions, useAppDispatch, useAppSelector, } from '@pomofocus/shared-client';
import { CONS } from '@pomofocus/core';
import { SHADOW_2 } from '../../constants';
import Modal from '../common/Modal';
import { Container } from '../styles/Layout';
import { ModalTitle } from '../styles/ModalStyles';
import { Paragraph02 } from '../styles/Text';
const KeyboardShortcutsModal = (props) => {
    const dispatch = useAppDispatch();
    const visibleModal = useAppSelector((state) => state.global.visibleModal);
    const closeModal = () => {
        dispatch(globalActions.changeVisibleModal({ visibleModal: null }));
    };
    return (React.createElement(Modal, { closeModal: closeModal, modalVisible: visibleModal === CONS.MODAL_KEYBORAD_SHORTCUTS, maxWidth: 480 },
        React.createElement(ModalContent, null,
            React.createElement(Title, null, "Keyboard Shortcuts"),
            React.createElement(Body, null,
                React.createElement(Table, null,
                    React.createElement("tbody", null,
                        React.createElement(Tr, null,
                            React.createElement(Th, null, "Command"),
                            React.createElement(Th, null, "Action")),
                        React.createElement(Tr, null,
                            React.createElement(Td, null,
                                React.createElement("kbd", null, "Space")),
                            React.createElement(Td, null, "Start/Pause timer")),
                        React.createElement(Tr, null,
                            React.createElement(Td, null,
                                React.createElement("kbd", null, "1")),
                            React.createElement(Td, null, "Switch to Pomodoro")),
                        React.createElement(Tr, null,
                            React.createElement(Td, null,
                                React.createElement("kbd", null, "2")),
                            React.createElement(Td, null, "Switch to Short Break")),
                        React.createElement(Tr, null,
                            React.createElement(Td, null,
                                React.createElement("kbd", null, "3")),
                            React.createElement(Td, null, "Switch to Long Break")),
                        React.createElement(Tr, null,
                            React.createElement(Td, null,
                                React.createElement("kbd", null, "T")),
                            React.createElement(Td, null, "Add new task")),
                        React.createElement(Tr, null,
                            React.createElement(Td, null,
                                React.createElement("kbd", null, "R")),
                            React.createElement(Td, null, "Open/Close Report")),
                        React.createElement(Tr, null,
                            React.createElement(Td, null,
                                React.createElement("kbd", null, "S")),
                            React.createElement(Td, null, "Open/Close Setting")),
                        React.createElement(Tr, null,
                            React.createElement(Td, null,
                                React.createElement("kbd", null, "Ctrl"),
                                " + ",
                                React.createElement("kbd", null, "T")),
                            React.createElement(Td, null, "Focus on task name")),
                        React.createElement(Tr, null,
                            React.createElement(Td, null,
                                React.createElement("kbd", null, "Ctrl"),
                                " + ",
                                React.createElement("kbd", null, "I")),
                            React.createElement(Td, null, "Increase task estimate")),
                        React.createElement(Tr, null,
                            React.createElement(Td, null,
                                React.createElement("kbd", null, "Ctrl"),
                                " + ",
                                React.createElement("kbd", null, "D")),
                            React.createElement(Td, null, "Decrease task estimate")),
                        React.createElement(Tr, null,
                            React.createElement(Td, null,
                                React.createElement("kbd", null, "Ctrl"),
                                " + ",
                                React.createElement("kbd", null, "N")),
                            React.createElement(Td, null, "Add note")),
                        React.createElement(Tr, null,
                            React.createElement(Td, null,
                                React.createElement("kbd", null, "Ctrl"),
                                " + ",
                                React.createElement("kbd", null, "P")),
                            React.createElement(Td, null, "Add project"))))))));
};
export default KeyboardShortcutsModal;
const ModalContent = styled.div `
  position: relative;
`;
const Title = styled.div `
  ${ModalTitle};
`;
export const Body = styled(Container) `
  padding: 0px 20px 30px 20px;
`;
export const ParagraphBig = styled.div `
  ${Paragraph02};
  font-size: 18px;
`;
export const Header = styled.h2 `
  color: #222;
  font-size: 22px;
  margin-bottom: 1rem;
  margin-top: 1.5rem;
`;
export const Paragraph = styled.div `
  ${Paragraph02}
  margin-bottom: 1rem;
`;
export const BodyImage = styled.img `
  width: 100%;
  margin-bottom: 1rem;
  border-radius: 0.5rem;
  box-shadow: ${SHADOW_2};
  width: ${(props) => props.width};
  max-width: 100%;
`;
const Table = styled.table `
  border-collapse: collapse;
  border: 1px solid #ddd;
  border-radius: 0.5rem;
  width: 100%;
  margin-top: 24px;
`;
const Tr = styled.tr ``;
const Th = styled.th `
  border: 1px solid #ddd;
  padding: 0.5rem;
  text-align: left;
`;
const Td = styled.td `
  border: 1px solid #ddd;
  padding: 0.5rem;
`;
